import React, { useMemo, useState } from "react";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import AuthProvider from "../../auth/AuthProvider";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import parseJSONTryCatched from "../../Helpers/JSONTryCatched";
import General from "./Tabs/General";
import RawApiData from "./Tabs/RawApiData";
import ChildProducts from "./Tabs/ChildProducts";
import { connect } from "react-redux";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";
import XPerGroupForY from "./Tabs/XPerGroupForY";
import ViewInCategory from "./Tabs/ViewInCategory";
import { SalesareaProvider } from "../Upsell/modernTS/salesarea/SalesareaContext";

const endPoint = "core/campaigns";

function CampaignForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);
  const [type, setType] = useState(null);

  const tabs = useMemo(() => {
    const tabs = [
      {
        right: "general",
        tabButton: <TranslationWrapper tDefault={"General"} tKey={"campaign.form.tabs.general"} />,
        tabContent: <General />,
      },
      {
        tabButton: <TranslationWrapper tDefault={"View in Category"} tKey={"campaign.form.tabs.view_in_category"} />,
        tabContent: <ViewInCategory />,
      },
    ];
    if (type === "X_PER_GROUP_FOR_Y") {
      tabs.push({
        tabButton: <TranslationWrapper tDefault={"XPerGroupForY"} tKey={"campaign.form.tabs.Products"} />,
        tabContent: <XPerGroupForY />,
      });
    } else {
      tabs.push({
        right: "Products",
        tabButton: <TranslationWrapper tDefault={"Products"} tKey={"campaign.form.tabs.Products"} />,
        tabContent: <ChildProducts />,
      });
    }

    tabs.push({
      right: "rawapidata",
      tabButton: <TranslationWrapper tDefault={"Raw api data"} tKey={"campaign.form.tabs.rawapidata"} />,
      tabContent: <RawApiData />,
    });
    return tabs;
  }, [type]);
  return (
    <AuthProvider prefix={"campaign"}>
      <CurrencyProvider currency={currency}>
        <SalesareaProvider salesareaId={vestiging?.id}>
          <VestigingProvider vestiging={vestiging}>
            <JamezzFormV2
              computedPageTitle={function (model) {
                return formatTitle(this.pageTitle, model.name);
              }}
              customFieldSerialization={{
                products: (products) => JSON.stringify(products),
                custom_data: (custom_data) => (custom_data ? JSON.stringify(custom_data) : null),
                x_per_group_for_y: (data) => (data ? JSON.stringify(data) : null),
                // child_product_groups: (child_product_groups) => JSON.stringify(child_product_groups),
              }}
              endPoint={endPoint}
              excludedKeysInOutput={{ raw_api_data: true }}
              extraFields={extraFields}
              extraFormProps={{ vestiging, vestigingId: vestiging?.id ?? props.vestiging_id, menukaartVestigingId }}
              mode={"onSubmit"}
              onGetModel={(model) => {
                setType(model.type);
                onGetModel(model);
              }}
              pageTitle={getTranslation("campaign.form.pageTitle", "Campaign")}
              pageTitleSubject={
                <small>
                  <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
                </small>
              }
              parseInput={{
                raw_api_data: (response) => (response ? parseJSONTryCatched(response) : null),
                products: (response) =>
                  response
                    ? response
                        .map((childProduct) => ({
                          id: childProduct.id,
                          naam: childProduct.naam,
                          sortkey: childProduct.sortkey,
                          pivot: childProduct.pivot,
                        }))
                        .sort((a, b) => (a.pivot.sort_key ?? a.sortkey) - (b.pivot.sort_key ?? b.sortkey))
                    : null,
                custom_data: (response) => (response ? parseJSONTryCatched(response) : []),
                // child_product_groups: (response) =>
                //   response
                //     ? response
                //         .map((childProductGroup) => ({
                //           id: childProductGroup.id,
                //           naam: childProductGroup.naam,
                //           sortkey: childProductGroup.sortkey,
                //           pivot: childProductGroup.pivot,
                //         }))
                //         .sort((a, b) => (a.pivot.sort_key ?? a.sortkey) - (b.pivot.sort_key ?? b.sortkey))
                //     : null,
                img_uuids: (response) => {
                  return response
                    ? JSON.parse(response).map((uuid) => ({
                        uuid: uuid,
                      }))
                    : [];
                },
              }}
              revalidateMode={"onChange"}
              rootRight={"campaign"}
              objectsExcludedAsRelation={{
                raw_api_data: true,
                products: true,
                x_per_group_for_y: true,
                // child_product_groups: true,
                // translations: true,
              }}
              // parseOutput2={{
              //   custom_data: (custom_data) => (custom_data ? JSON.stringify(custom_data) : null),
              // }}
              tabs={tabs}
            />
          </VestigingProvider>
        </SalesareaProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(CampaignForm, vestigingStyle));
